// React
import { useEffect, useState } from "react";
import { accountFormat } from "@Common/helpers/number";

// Types
type AnimatedLabelProps = {
	viewBox: { cx: number; cy: number };
	finalValue: number;
};

// Constants
const DIGIT_SCALING_FACTOR = 10;
const ADJUSTMENT_VALUE = 15;
const INCREMENT_FACTOR = 0.05;

const AnimatedLabel = ({ viewBox, finalValue }: Readonly<AnimatedLabelProps>) => {
	const validFinalValue = finalValue || 0;
	const { cx, cy } = viewBox;

	const [currentValue, setCurrentValue] = useState(0);

	const toAdjustX = (value: number) => {
		const valueDigits = [...value.toString()].length;
		return valueDigits * DIGIT_SCALING_FACTOR + ADJUSTMENT_VALUE;
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			setCurrentValue((prevValue) => {
				const diff = validFinalValue - prevValue;
				const increment = Math.max(1, Math.floor(Math.abs(diff) * INCREMENT_FACTOR)); // Increment by 10% of the remaining value
				const newValue = prevValue + (diff > 0 ? increment : -increment);

				if (Math.abs(validFinalValue - newValue) <= 1) {
					// Tolerance due to increment
					clearInterval(intervalId);
					return validFinalValue; // Ensure the final value is set correctly
				}

				return newValue;
			});
		}, 1); // You may need to adjust the delay to control the speed

		return () => clearInterval(intervalId); // Clear timeout on unmounting
	}, [validFinalValue]); // Removed currentValue from dependencies

	return (
		<g>
			<text
				x={cx - toAdjustX(currentValue)}
				y={cy - 70}
				style={{ fontWeight: "600" }}
				textAnchor="start"
				dominantBaseline="middle"
				fontSize={"15px"}
				fontFamily={"Montserrat"}
				fill={"#636363"}
			>
				$
			</text>
			<text
				x={cx + 7}
				y={cy - 60}
				style={{ fontWeight: "600" }}
				textAnchor="middle"
				dominantBaseline="middle"
				fontSize={"38px"}
				fontFamily={"Montserrat"}
				fill={"#636363"}
			>
				{accountFormat(currentValue, 0) === "-" ? "0" : accountFormat(currentValue, 0)}
			</text>
		</g>
	);
};

export default AnimatedLabel;
